import agency from 'i18n/adsimple/en/agency.yml'
import auth from 'i18n/adsimple/en/auth.yml'
import autoreplenish from 'i18n/adsimple/en/autoreplenish.yml'
import banners from 'i18n/adsimple/en/banners.yml'
import billing from 'i18n/adsimple/en/billing.yml'
import common from 'i18n/adsimple/en/common.yml'
import oauth from 'i18n/adsimple/en/oauth.yml'
import promised_payment from 'i18n/adsimple/en/promised_payment.yml'
import pulse from 'i18n/adsimple/en/pulse.yml'
import recommendations from 'i18n/adsimple/en/recommendations.yml'
import referral from 'i18n/adsimple/en/referral.yml'
import services from 'i18n/adsimple/en/services.yml'
import statistics from 'i18n/adsimple/en/statistics.yml'
import user from 'i18n/adsimple/en/user.yml'
import finance from 'i18n/adsimple/en/finance.yml'
import industries from 'i18n/adsimple/en/industries.yml'
import tickets from 'i18n/adsimple/en/tickets.yml'
import form_errors from 'i18n/adsimple/en/form_errors.yml'
import payment_order from 'i18n/adsimple/en/payment_order.yml'
import partners_program from 'i18n/adsimple/en/partners_program.yml'
import reward_calculator from 'i18n/adsimple/en/reward_calculator.yml'
import campaigns_editor from 'i18n/adsimple/en/campaigns_editor.yml'
import advertisers from 'i18n/adsimple/en/advertisers.yml'
import media_planner from 'i18n/adsimple/en/media_planner.yml'
import countries from 'i18n/adsimple/en/countries.yml'
import cookie_banner from 'i18n/adsimple/en/cookie-banner.yml'
import accounts_marketplace from 'i18n/adsimple/en/accounts_marketplace.yml'
import audits from 'i18n/adsimple/en/audits.yml'
import benchmarks from 'i18n/adsimple/en/benchmarks.yml'
import payment_profiles from 'i18n/adsimple/en/payment_profiles.yml'
import wallets from 'i18n/adsimple/en/wallets.yml'
import invoices from 'i18n/adsimple/en/invoices.yml'

export default {
  audits,
  benchmarks,
  common,
  services,
  banners,
  agency,
  statistics,
  referral,
  user,
  pulse,
  billing,
  autoreplenish,
  oauth,
  finance,
  wallets,
  payment_profiles,
  promised_payment,
  recommendations,
  industries,
  auth,
  tickets,
  payment_order,
  form_errors,
  partners_program,
  reward_calculator,
  campaigns_editor,
  advertisers,
  media_planner,
  countries,
  cookie_banner,
  accounts_marketplace,
  invoices,
}
